export const selectStyles = (config = false) => {
    const isError = config === true || 
                    (typeof config === 'string' && config !== "") || 
                    (typeof config === 'object' && config.error);
    const isCompact = typeof config === 'object' && config.compact;
    const customMaxHeight = typeof config === 'object' && config.maxHeight;
    const isMultiScroll = typeof config === 'object' && config.isMultiScroll;
    
    return {
        control: (base, state) => ({
            ...base,
            borderRadius: "8px",
            minHeight: isCompact ? "36px" : "44px",
            maxHeight: isMultiScroll ? "44px" : "none",
            borderColor: state.isDisabled ? "#e5e7eb" : (state.isFocused ? "#ed1c24" : isError ? "#dc3545" : "#d1d5db"),
            boxShadow: state.isFocused ? "0 0 0 1px #ed1c24" : "none",
            backgroundColor: state.isDisabled ? "#f3f4f6" : "white",
            cursor: state.isDisabled ? "not-allowed" : "default",
            fontSize: isCompact ? "13px" : "15px", // Slightly larger font
            opacity: state.isDisabled ? 0.8 : 1,
            "&:hover": {
                borderColor: state.isDisabled ? "#e5e7eb" : (state.isFocused ? "#ed1c24" : isError ? "#dc3545" : "#d1d5db"),
            },
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#ed1c24" : state.isFocused ? "#f8d7da" : "white",
            color: state.isSelected ? "white" : "black",
            padding: isCompact ? "6px 12px" : "10px 15px",
            fontSize: isCompact ? "13px" : "14px",
            "&:active": {
                backgroundColor: "#ed1c24",
                color: "white",
            },
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#ed1c24", // Solid brand red
            borderRadius: "6px",
            padding: "1px 3px",
            alignItems: "center",
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "white",
            fontWeight: "600",
            fontSize: "12px",
            padding: "2px 4px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "white",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "#b30006", // Darker red on hover
                color: "white",
                borderRadius: "0 6px 6px 0",
            },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "8px",
            zIndex: 9999,
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: customMaxHeight || "200px", // Custom or default option list height
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        singleValue: (base, state) => ({
            ...base,
            color: state.isDisabled ? "#6b7280" : "#495057",
            margin: 0,
            padding: 0,
            fontWeight: state.isDisabled ? "500" : "normal",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#6c757d",
        }),
        valueContainer: (base) => ({
            ...base,
            padding: isCompact ? "0 8px" : "0 12px",
            display: "flex",
            flexWrap: isCompact ? "nowrap" : "wrap",
            alignItems: "center",
            gap: "6px",
            paddingTop: isCompact ? "2px" : "4px",
            paddingBottom: isCompact ? "2px" : "4px",
            maxHeight: isMultiScroll ? "38px" : "none",
            overflowY: isMultiScroll ? "auto" : "visible",
            "&::-webkit-scrollbar": {
                width: "4px",
            },
            "&::-webkit-scrollbar-track": {
                background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#ed1c2455",
                borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
                background: "#ed1c2488",
            },
        }),
        indicatorsContainer: (base, state) => ({
            ...base,
            height: isCompact ? "34px" : "44px",
            display: state.isDisabled ? "none" : "flex",
        }),
        indicatorSeparator: () => ({
            display: "none",
        }),
        dropdownIndicator: (base, state) => ({
            ...base,
            display: state.isDisabled ? "none" : "block",
        }),
    };
};
